import DOMPurify from "dompurify";

// Client-side sanitiser for admin-authored rich content (defence in depth —
// the backend also sanitises on save). Allows callout boxes + tables.
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "h2", "h3", "h4", "h5", "h6",
    "strong", "b", "em", "i", "u", "s", "sub", "sup",
    "ul", "ol", "li", "a", "img", "blockquote",
    "table", "thead", "tbody", "tr", "th", "td", "div", "span",
  ],
  ALLOWED_ATTR: ["href", "title", "target", "rel", "src", "alt", "width", "height",
    "loading", "class", "colspan", "rowspan", "scope", "data-variant"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
};

export function cleanHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, CONFIG);
}
